export const translations = {
  en: {
    page_title: "E2 Parking - Smart Parking Solutions",
    nav_overview: "Overview",
    nav_benefits: "Benefits",
    nav_features: "Features",
    nav_tech: "Tech",
    nav_usecases: "Use Cases",
    nav_roi: "ROI",
    nav_pricing: "Pricing",
    nav_contact: "Contact",
    hero_title: "Smart parking. No cables. No stress.",
    hero_subtitle: "Detection, counting, reservation and payment — indoor & outdoor — installation in just a few hours.",
    hero_cta: "Request a Demo",
    benefits_title: "Key Benefits",
    benefits_subtitle: "Transform your parking infrastructure with cutting-edge IoT technology",
    benefit1_title: "Wireless & Fast",
    benefit1_desc: "Floor or wall-mounted sensors, installed in minutes with no cabling required.",
    benefit2_title: "Accurate Counting",
    benefit2_desc: "Real-time availability tracking with precision detection for every parking space.",
    benefit3_title: "Reservation & Access",
    benefit3_desc: "Seamless booking system for employees, visitors, and residents with smart access control.",
    benefit4_title: "Integrated Payment",
    benefit4_desc: "QR code, app, or badge payment options with comprehensive reporting and exports.",
    features_title: "Features",
    features_subtitle: "Comprehensive smart parking technology for modern infrastructure",
    feature1_title: "Wireless Sensors",
    feature1_desc: "NB-IoT/LTE/BLE/Sigfox/LoRa/Mioty connectivity with 5+ years battery autonomy. No maintenance required.",
    feature2_title: "Anti-Illegal Parking",
    feature2_desc: "Instant alerts for unauthorized vehicles and restricted zone violations.",
    feature3_title: "Indoor & Outdoor",
    feature3_desc: "IP67 rated sensors resistant to snow, rain, and extreme conditions. Perfect for underground garages.",
    feature4_title: "Simple Dashboard",
    feature4_desc: "Real-time monitoring across multiple sites with customizable zone tags and analytics.",
    feature5_title: "API & Integrations",
    feature5_desc: "Connect with barriers, LPR/ANPR systems, charging stations, and SSO authentication.",
    feature6_title: "Reports & ROI",
    feature6_desc: "Track occupancy rates, peak times, and monetization opportunities with detailed analytics.",
    tech_title: "Technology & Installation",
    tech_desc: "Install today, use tomorrow: pre-configured sensors with no cables and no local network required. Backhaul via NB-IoT/LTE/BLE/Sigfox/LoRa/Mioty with E2 cloud supervision.",
    tech_list1: "Floor mounting (chemical anchor/epoxy) or wall/pole installation",
    tech_list2: "Auto-calibration and high-precision vehicle detection",
    tech_list3: "Cloud maintenance and OTA firmware updates",
    usecases_title: "Use Cases",
    usecase1_title: "Cities & Public Parking",
    usecase1_desc: "Combat illegal parking, provide real-time guidance, and monetize street parking with smart enforcement.",
    usecase2_title: "Enterprises & Campuses",
    usecase2_desc: "Enable employee reservations, visitor management, and usage KPIs for optimized workplace parking.",
    usecase3_title: "Shopping Centers & Hospitals",
    usecase3_desc: "Monitor traffic flow, peak times, integrate payments, and capture real-time usage data.",
    roi_title: "ROI & Proof Points",
    roi_subtitle: "Measurable impact on your parking operations",
    roi1_value: "< 1 Day",
    roi1_label: "Installation Time",
    roi2_value: "+15-30%",
    roi2_label: "Perceived Availability",
    roi3_value: "< 6 Months",
    roi3_label: "Typical ROI",
    roi4_value: "99%",
    roi4_label: "Detection Accuracy",
    roi_note: "Figures are indicative and depend on configuration, site size, and integrations.",
    pricing_title: "Simple Pricing",
    pricing_subtitle: "Flexible plans for every parking need",
    plan1_title: "Starter (Pilot)",
    plan1_desc: "10-30 parking spaces, dashboard access, standard support, and basic analytics.",
    plan2_title: "Pro (Single Site)",
    plan2_desc: "Multi-zone management, reservations, integrated payment, data exports, and priority support.",
    plan3_title: "Multi-Sites",
    plan3_desc: "Organization accounts, SSO, priority API access, dedicated SLA, and custom integrations.",
    pricing_cta: "Get an Estimate",
    contact_title: "Contact Us",
    contact_subtitle: "Get in touch to discuss your smart parking needs",
    contact_name: "Name *",
    contact_email: "Email *",
    contact_phone: "Phone (Optional)",
    contact_company: "Company (Optional)",
    contact_message: "Message *",
    contact_submit: "Send Message",
    contact_note: "Sending will open your default email client.",
    footer_lithuania: "Lithuania",
    footer_latvia: "Latvia",
    footer_email: "Email",
    footer_copyright: "© 2025 E2 Technologies OU / 0g Baltics. All rights reserved."
  },
  fr: {
    page_title: "E2 Parking - Solutions de Stationnement Intelligentes",
    nav_overview: "Vue d'ensemble",
    nav_benefits: "Avantages",
    nav_features: "Fonctionnalités",
    nav_tech: "Technologie",
    nav_usecases: "Cas d'usage",
    nav_roi: "ROI",
    nav_pricing: "Tarifs",
    nav_contact: "Contact",
    hero_title: "Stationnement intelligent. Sans câbles. Sans stress.",
    hero_subtitle: "Détection, comptage, réservation et paiement — intérieur & extérieur — installation en quelques heures.",
    hero_cta: "Demander une démo",
    benefits_title: "Avantages clés",
    benefits_subtitle: "Transformez votre infrastructure de stationnement avec la technologie IoT",
    benefit1_title: "Sans fil & rapide",
    benefit1_desc: "Capteurs au sol ou muraux, installés en minutes sans câblage.",
    benefit2_title: "Comptage précis",
    benefit2_desc: "Suivi de disponibilité en temps réel avec détection de précision pour chaque place.",
    benefit3_title: "Réservation & accès",
    benefit3_desc: "Système de réservation pour employés, visiteurs et résidents avec contrôle d'accès intelligent.",
    benefit4_title: "Paiement intégré",
    benefit4_desc: "Options QR code, app ou badge avec rapports complets et exports.",
    features_title: "Fonctionnalités",
    features_subtitle: "Technologie complète de stationnement intelligent",
    feature1_title: "Capteurs sans fil",
    feature1_desc: "Connectivité NB-IoT/LTE/BLE/Sigfox/LoRa/Mioty avec autonomie de 5+ ans. Aucune maintenance requise.",
    feature2_title: "Anti-stationnement sauvage",
    feature2_desc: "Alertes instantanées pour véhicules non autorisés et violations de zones interdites.",
    feature3_title: "Intérieur & extérieur",
    feature3_desc: "Capteurs IP67 résistants à la neige, pluie et conditions extrêmes. Parfait pour parkings souterrains.",
    feature4_title: "Tableau de bord simple",
    feature4_desc: "Surveillance en temps réel multi-sites avec tags de zones personnalisables.",
    feature5_title: "API & intégrations",
    feature5_desc: "Connexion avec barrières, systèmes LPR/ANPR, bornes de recharge et SSO.",
    feature6_title: "Rapports & ROI",
    feature6_desc: "Suivi des taux d'occupation, heures de pointe et opportunités de monétisation.",
    tech_title: "Technologie & installation",
    tech_desc: "Installez aujourd'hui, utilisez demain : capteurs préconfigurés sans câbles ni réseau local. Liaison NB-IoT/LTE/BLE/Sigfox/LoRa/Mioty avec supervision cloud E2.",
    tech_list1: "Pose au sol (cheville chimique/époxy) ou mur/poteau",
    tech_list2: "Auto-étalonnage et détection véhicule haute précision",
    tech_list3: "Maintenance cloud et mises à jour OTA",
    usecases_title: "Cas d'usage",
    usecase1_title: "Villes & parkings publics",
    usecase1_desc: "Lutter contre le stationnement sauvage, guidage temps réel et monétisation avec contrôle intelligent.",
    usecase2_title: "Entreprises & campus",
    usecase2_desc: "Réservations employés, gestion visiteurs et KPI d'usage pour parking optimisé.",
    usecase3_title: "Centres commerciaux & hôpitaux",
    usecase3_desc: "Surveillance flux, heures de pointe, paiement intégré et données temps réel.",
    roi_title: "ROI & preuves",
    roi_subtitle: "Impact mesurable sur vos opérations",
    roi1_value: "< 1 jour",
    roi1_label: "Installation",
    roi2_value: "+15-30%",
    roi2_label: "Disponibilité perçue",
    roi3_value: "< 6 mois",
    roi3_label: "ROI typique",
    roi4_value: "99%",
    roi4_label: "Précision détection",
    roi_note: "Chiffres indicatifs selon configuration, taille du site et intégrations.",
    pricing_title: "Tarification simple",
    pricing_subtitle: "Plans flexibles pour tous besoins",
    plan1_title: "Starter (pilote)",
    plan1_desc: "10-30 places, tableau de bord, support standard et analyses basiques.",
    plan2_title: "Pro (site unique)",
    plan2_desc: "Gestion multi-zones, réservations, paiement intégré, exports et support prioritaire.",
    plan3_title: "Multi-sites",
    plan3_desc: "Comptes organisation, SSO, API prioritaire, SLA dédié et intégrations personnalisées.",
    pricing_cta: "Obtenir une estimation",
    contact_title: "Contactez-nous",
    contact_subtitle: "Discutez de vos besoins en stationnement intelligent",
    contact_name: "Nom *",
    contact_email: "Email *",
    contact_phone: "Téléphone (optionnel)",
    contact_company: "Société (optionnel)",
    contact_message: "Message *",
    contact_submit: "Envoyer",
    contact_note: "L'envoi ouvrira votre client email par défaut.",
    footer_lithuania: "Lituanie",
    footer_latvia: "Lettonie",
    footer_email: "Email",
    footer_copyright: "© 2025 E2 Technologies OU / 0g Baltics. Tous droits réservés."
  },
  de: {
    page_title: "E2 Parking - Intelligente Parklösungen",
    nav_overview: "Übersicht",
    nav_benefits: "Vorteile",
    nav_features: "Funktionen",
    nav_tech: "Technik",
    nav_usecases: "Anwendungsfälle",
    nav_roi: "ROI",
    nav_pricing: "Preise",
    nav_contact: "Kontakt",
    hero_title: "Smartes Parken. Keine Kabel. Kein Stress.",
    hero_subtitle: "Erkennung, Zählung, Reservierung und Zahlung — innen & außen — Installation in wenigen Stunden.",
    hero_cta: "Demo anfordern",
    benefits_title: "Hauptvorteile",
    benefits_subtitle: "Transformieren Sie Ihre Parkinfrastruktur mit IoT-Technologie",
    benefit1_title: "Drahtlos & schnell",
    benefit1_desc: "Boden- oder wandmontierte Sensoren, in Minuten ohne Verkabelung installiert.",
    benefit2_title: "Präzise Zählung",
    benefit2_desc: "Echtzeit-Verfügbarkeitsverfolgung mit präziser Erkennung für jeden Parkplatz.",
    benefit3_title: "Reservierung & Zugang",
    benefit3_desc: "Nahtloses Buchungssystem für Mitarbeiter, Besucher und Bewohner mit intelligentem Zugang.",
    benefit4_title: "Integrierte Zahlung",
    benefit4_desc: "QR-Code, App oder Badge-Zahlung mit umfassenden Berichten und Exporten.",
    features_title: "Funktionen",
    features_subtitle: "Umfassende Smart-Parking-Technologie",
    feature1_title: "Drahtlose Sensoren",
    feature1_desc: "NB-IoT/LTE/BLE/Sigfox/LoRa/Mioty-Konnektivität mit 5+ Jahren Batterieautonomie. Keine Wartung erforderlich.",
    feature2_title: "Anti-Falschparken",
    feature2_desc: "Sofortige Warnungen für nicht autorisierte Fahrzeuge und Sperrzonenverletzungen.",
    feature3_title: "Innen & außen",
    feature3_desc: "IP67-zertifizierte Sensoren, resistent gegen Schnee, Regen und Extrembedingungen. Perfekt für Tiefgaragen.",
    feature4_title: "Einfaches Dashboard",
    feature4_desc: "Echtzeit-Überwachung mehrerer Standorte mit anpassbaren Zonen-Tags.",
    feature5_title: "API & Integrationen",
    feature5_desc: "Verbindung mit Schranken, LPR/ANPR-Systemen, Ladestationen und SSO.",
    feature6_title: "Berichte & ROI",
    feature6_desc: "Verfolgung von Belegungsraten, Spitzenzeiten und Monetarisierungsmöglichkeiten.",
    tech_title: "Technologie & Installation",
    tech_desc: "Heute installieren, morgen nutzen: vorkonfigurierte Sensoren ohne Kabel und lokales Netzwerk. Backhaul via NB-IoT/LTE/BLE/Sigfox/LoRa/Mioty mit E2 Cloud-Überwachung.",
    tech_list1: "Bodenmontage (Chemiedübel/Epoxid) oder Wand-/Mastinstallation",
    tech_list2: "Auto-Kalibrierung und hochpräzise Fahrzeugerkennung",
    tech_list3: "Cloud-Wartung und OTA-Firmware-Updates",
    usecases_title: "Anwendungsfälle",
    usecase1_title: "Städte & öffentliches Parken",
    usecase1_desc: "Bekämpfung illegalen Parkens, Echtzeit-Führung und Monetarisierung mit intelligenter Durchsetzung.",
    usecase2_title: "Unternehmen & Campus",
    usecase2_desc: "Mitarbeiterreservierungen, Besucherverwaltung und Nutzungs-KPIs für optimiertes Parken.",
    usecase3_title: "Einkaufszentren & Krankenhäuser",
    usecase3_desc: "Verkehrsflussüberwachung, Spitzenzeiten, Zahlungsintegration und Echtzeitdaten.",
    roi_title: "ROI & Nachweise",
    roi_subtitle: "Messbare Auswirkungen auf Ihren Parkbetrieb",
    roi1_value: "< 1 Tag",
    roi1_label: "Installationszeit",
    roi2_value: "+15-30%",
    roi2_label: "Wahrgenommene Verfügbarkeit",
    roi3_value: "< 6 Monate",
    roi3_label: "Typischer ROI",
    roi4_value: "99%",
    roi4_label: "Erkennungsgenauigkeit",
    roi_note: "Zahlen sind indikativ und hängen von Konfiguration, Standortgröße und Integrationen ab.",
    pricing_title: "Einfache Preise",
    pricing_subtitle: "Flexible Pläne für jeden Parkbedarf",
    plan1_title: "Starter (Pilot)",
    plan1_desc: "10-30 Parkplätze, Dashboard-Zugang, Standard-Support und Basisanalysen.",
    plan2_title: "Pro (Einzelstandort)",
    plan2_desc: "Multi-Zonen-Management, Reservierungen, integrierte Zahlung, Datenexporte und Priority-Support.",
    plan3_title: "Multi-Standorte",
    plan3_desc: "Organisationskonten, SSO, Priority-API-Zugang, dediziertes SLA und Custom-Integrationen.",
    pricing_cta: "Angebot einholen",
    contact_title: "Kontaktieren Sie uns",
    contact_subtitle: "Besprechen Sie Ihre Smart-Parking-Anforderungen",
    contact_name: "Name *",
    contact_email: "E-Mail *",
    contact_phone: "Telefon (optional)",
    contact_company: "Firma (optional)",
    contact_message: "Nachricht *",
    contact_submit: "Nachricht senden",
    contact_note: "Das Senden öffnet Ihren Standard-E-Mail-Client.",
    footer_lithuania: "Litauen",
    footer_latvia: "Lettland",
    footer_email: "E-Mail",
    footer_copyright: "© 2025 E2 Technologies OU / 0g Baltics. Alle Rechte vorbehalten."
  },
  lt: {
    page_title: "E2 Parking - Išmanios Parkavimo Sistemos",
    nav_overview: "Apžvalga",
    nav_benefits: "Privalumai",
    nav_features: "Funkcijos",
    nav_tech: "Technologija",
    nav_usecases: "Panaudojimo atvejai",
    nav_roi: "ROI",
    nav_pricing: "Kainos",
    nav_contact: "Kontaktai",
    hero_title: "Išmanus parkavimas. Be laidų. Be streso.",
    hero_subtitle: "Aptikimas, skaičiavimas, rezervacija ir mokėjimas — viduje ir lauke — įdiegimas per kelias valandas.",
    hero_cta: "Užsakyti demonstraciją",
    benefits_title: "Pagrindiniai privalumai",
    benefits_subtitle: "Transformuokite parkavimo infrastruktūrą su IoT technologija",
    benefit1_title: "Belaidis & greitas",
    benefit1_desc: "Grindyse ar ant sienos montuojami jutikliai, įdiegiami per minutes be laidų.",
    benefit2_title: "Tikslus skaičiavimas",
    benefit2_desc: "Realaus laiko prieinamumo stebėjimas su tiksliu kiekvienos vietos aptikimu.",
    benefit3_title: "Rezervacija ir prieiga",
    benefit3_desc: "Sklandžių rezervacijų sistema darbuotojams, lankytojams ir gyventojams su išmaniuoju prieigos valdymu.",
    benefit4_title: "Integruotas mokėjimas",
    benefit4_desc: "QR kodas, programėlė ar kortelė su išsamiomis ataskaitomis ir eksportais.",
    features_title: "Funkcijos",
    features_subtitle: "Išsami išmanaus parkavimo technologija",
    feature1_title: "Belaidžiai jutikliai",
    feature1_desc: "NB-IoT/LTE/BLE/Sigfox/LoRa/Mioty ryšys su 5+ metų baterijos autonomija. Priežiūra nereikalinga.",
    feature2_title: "Anti-neteisėtas parkavimas",
    feature2_desc: "Momentiniai įspėjimai dėl neautorizuotų transporto priemonių ir draudžiamų zonų pažeidimų.",
    feature3_title: "Viduje ir lauke",
    feature3_desc: "IP67 jutikliai atsparūs sniegui, lietui ir ekstremaliosioms sąlygoms. Tobula požeminiams garažams.",
    feature4_title: "Paprastas valdymo skydelis",
    feature4_desc: "Realaus laiko stebėjimas keliose vietose su pritaikomomis zonų žymomis.",
    feature5_title: "API ir integracijos",
    feature5_desc: "Prijungimas prie barjerų, LPR/ANPR sistemų, įkrovimo stočių ir SSO.",
    feature6_title: "Ataskaitos ir ROI",
    feature6_desc: "Užimtumo rodiklių, pikinių laikų ir monetizavimo galimybių stebėjimas.",
    tech_title: "Technologija ir įdiegimas",
    tech_desc: "Įdiekite šiandien, naudokite rytoj: iš anksto sukonfigūruoti jutikliai be laidų ir vietinio tinklo. Ryšys per NB-IoT/LTE/BLE/Sigfox/LoRa/Mioty su E2 debesų priežiūra.",
    tech_list1: "Montavimas ant grindų (cheminis inkaras/epoksidas) arba sienos/stulpo",
    tech_list2: "Auto-kalibravimas ir didelio tikslumo transporto priemonių aptikimas",
    tech_list3: "Debesų priežiūra ir OTA programinės įrangos naujinimai",
    usecases_title: "Panaudojimo atvejai",
    usecase1_title: "Miestai ir viešas parkavimas",
    usecase1_desc: "Kova su neteisėtu parkavimu, realaus laiko nukreipimas ir monetizavimas su išmaniuoju vykdymu.",
    usecase2_title: "Įmonės ir kampusai",
    usecase2_desc: "Darbuotojų rezervacijos, lankytojų valdymas ir naudojimo KPI optimizuotam parkavimui.",
    usecase3_title: "Prekybos centrai ir ligoninės",
    usecase3_desc: "Eismo srauto stebėjimas, pikiniai laikai, mokėjimo integracija ir realaus laiko duomenys.",
    roi_title: "ROI ir įrodymai",
    roi_subtitle: "Išmatuojamas poveikis jūsų parkavimo operacijoms",
    roi1_value: "< 1 diena",
    roi1_label: "Įdiegimo laikas",
    roi2_value: "+15-30%",
    roi2_label: "Suvoktas prieinamumas",
    roi3_value: "< 6 mėnesiai",
    roi3_label: "Tipinis ROI",
    roi4_value: "99%",
    roi4_label: "Aptikimo tikslumas",
    roi_note: "Skaičiai orientaciniai ir priklauso nuo konfigūracijos, vietos dydžio ir integracijų.",
    pricing_title: "Paprasta kainodara",
    pricing_subtitle: "Lankstūs planai kiekvienam parkavimo poreikiui",
    plan1_title: "Starteris (bandomasis)",
    plan1_desc: "10-30 parkavimo vietų, prieiga prie valdymo skydelio, standartinė pagalba ir bazinė analitika.",
    plan2_title: "Pro (viena vieta)",
    plan2_desc: "Kelių zonų valdymas, rezervacijos, integruotas mokėjimas, duomenų eksportai ir prioritetinė pagalba.",
    plan3_title: "Kelios vietos",
    plan3_desc: "Organizacijos paskyros, SSO, prioritetinė API prieiga, dedikuotas SLA ir pasirinktinės integracijos.",
    pricing_cta: "Gauti įvertinimą",
    contact_title: "Susisiekite su mumis",
    contact_subtitle: "Aptarkite savo išmanaus parkavimo poreikius",
    contact_name: "Vardas *",
    contact_email: "El. paštas *",
    contact_phone: "Telefonas (neprivaloma)",
    contact_company: "Įmonė (neprivaloma)",
    contact_message: "Žinutė *",
    contact_submit: "Siųsti žinutę",
    contact_note: "Siunčiant atidarys jūsų numatytąjį el. pašto klientą.",
    footer_lithuania: "Lietuva",
    footer_latvia: "Latvija",
    footer_email: "El. paštas",
    footer_copyright: "© 2025 E2 Technologies OU / 0g Baltics. Visos teisės saugomos."
  },
  lv: {
    page_title: "E2 Parking - Viedās Stāvvietu Sistēmas",
    nav_overview: "Pārskats",
    nav_benefits: "Priekšrocības",
    nav_features: "Funkcijas",
    nav_tech: "Tehnoloģija",
    nav_usecases: "Lietojuma gadījumi",
    nav_roi: "ROI",
    nav_pricing: "Cenas",
    nav_contact: "Kontakti",
    hero_title: "Viedā stāvvieta. Bez kabeļiem. Bez stresa.",
    hero_subtitle: "Noteikšana, skaitīšana, rezervācija un maksājums — telpās un ārpus telpām — uzstādīšana dažās stundās.",
    hero_cta: "Pieprasīt demonstrāciju",
    benefits_title: "Galvenās priekšrocības",
    benefits_subtitle: "Pārveidojiet savu stāvvietu infrastruktūru ar IoT tehnoloģiju",
    benefit1_title: "Bezvadu un ātrs",
    benefit1_desc: "Grīdā vai uz sienas montējami sensori, uzstādīti minūtēs bez kabeļiem.",
    benefit2_title: "Precīza skaitīšana",
    benefit2_desc: "Reāllaika pieejamības izsekošana ar precīzu noteikšanu katrai stāvvietai.",
    benefit3_title: "Rezervācija un piekļuve",
    benefit3_desc: "Netraucēta rezervāciju sistēma darbiniekiem, apmeklētājiem un iedzīvotājiem ar viedu piekļuves kontroli.",
    benefit4_title: "Integrēts maksājums",
    benefit4_desc: "QR kods, aplikācija vai karte ar visaptverošiem pārskatiem un eksportiem.",
    features_title: "Funkcijas",
    features_subtitle: "Visaptveroša viedās stāvvietas tehnoloģija",
    feature1_title: "Bezvadu sensori",
    feature1_desc: "NB-IoT/LTE/BLE/Sigfox/LoRa/Mioty savienojums ar 5+ gadu baterijas autonomiju. Nav nepieciešama apkope.",
    feature2_title: "Anti-nelikumīga stāvēšana",
    feature2_desc: "Tūlītēji brīdinājumi par neatļautiem transportlīdzekļiem un aizliegto zonu pārkāpumiem.",
    feature3_title: "Telpās un ārpus telpām",
    feature3_desc: "IP67 sensori, izturīgi pret sniegu, lietu un ekstrēmiem apstākļiem. Ideāli pazemes garāžām.",
    feature4_title: "Vienkārša vadības panelis",
    feature4_desc: "Reāllaika uzraudzība vairākās vietās ar pielāgojamām zonu iezīmēm.",
    feature5_title: "API un integrācijas",
    feature5_desc: "Savienojums ar barjerām, LPR/ANPR sistēmām, uzlādes stacijām un SSO.",
    feature6_title: "Pārskati un ROI",
    feature6_desc: "Aizņemtības rādītāju, maksimālo laiku un monetizācijas iespēju izsekošana.",
    tech_title: "Tehnoloģija un uzstādīšana",
    tech_desc: "Uzstādiet šodien, lietojiet rīt: iepriekš konfigurēti sensori bez kabeļiem un vietējā tīkla. Savienojums caur NB-IoT/LTE/BLE/Sigfox/LoRa/Mioty ar E2 mākoņa uzraudzību.",
    tech_list1: "Grīdas montāža (ķīmiskais enkurs/epoksīds) vai sienas/staba uzstādīšana",
    tech_list2: "Auto-kalibrācija un augstas precizitātes transportlīdzekļu noteikšana",
    tech_list3: "Mākoņa apkope un OTA programmaparatūras atjauninājumi",
    usecases_title: "Lietojuma gadījumi",
    usecase1_title: "Pilsētas un publiskas stāvvietas",
    usecase1_desc: "Cīņa ar nelikumīgu stāvēšanu, reāllaika vadība un monetizācija ar viedu izpildi.",
    usecase2_title: "Uzņēmumi un kampusi",
    usecase2_desc: "Darbinieku rezervācijas, apmeklētāju pārvaldība un lietošanas KPI optimizētai stāvvietai.",
    usecase3_title: "Tirdzniecības centri un slimnīcas",
    usecase3_desc: "Satiksmes plūsmas uzraudzība, maksimālie laiki, maksājumu integrācija un reāllaika dati.",
    roi_title: "ROI un pierādījumi",
    roi_subtitle: "Izmērāma ietekme uz jūsu stāvvietu operācijām",
    roi1_value: "< 1 diena",
    roi1_label: "Uzstādīšanas laiks",
    roi2_value: "+15-30%",
    roi2_label: "Uztvertā pieejamība",
    roi3_value: "< 6 mēneši",
    roi3_label: "Tipiskais ROI",
    roi4_value: "99%",
    roi4_label: "Noteikšanas precizitāte",
    roi_note: "Skaitļi ir orientējoši un ir atkarīgi no konfigurācijas, vietas lieluma un integrācijām.",
    pricing_title: "Vienkārša cenu noteikšana",
    pricing_subtitle: "Elastīgi plāni katrai stāvvietas vajadzībai",
    plan1_title: "Sākuma (pilots)",
    plan1_desc: "10-30 stāvvietas, vadības paneļa piekļuve, standarta atbalsts un pamata analītika.",
    plan2_title: "Pro (viena vieta)",
    plan2_desc: "Vairāku zonu pārvaldība, rezervācijas, integrēts maksājums, datu eksporti un prioritārs atbalsts.",
    plan3_title: "Vairākas vietas",
    plan3_desc: "Organizācijas konti, SSO, prioritāra API piekļuve, īpašs SLA un pielāgotas integrācijas.",
    pricing_cta: "Saņemt novērtējumu",
    contact_title: "Sazinieties ar mums",
    contact_subtitle: "Apspriediet savas viedās stāvvietas vajadzības",
    contact_name: "Vārds *",
    contact_email: "E-pasts *",
    contact_phone: "Tālrunis (neobligāti)",
    contact_company: "Uzņēmums (neobligāti)",
    contact_message: "Ziņojums *",
    contact_submit: "Nosūtīt ziņojumu",
    contact_note: "Nosūtot atvērsies jūsu noklusējuma e-pasta klients.",
    footer_lithuania: "Lietuva",
    footer_latvia: "Latvija",
    footer_email: "E-pasts",
    footer_copyright: "© 2025 E2 Technologies OU / 0g Baltics. Visas tiesības aizsargātas."
  }
};